const env = {
    url: 'https://personaljulia.techvision.dev/',
    api: 'https://api-personaljulia.techvision.dev/api/v1/',
    title: 'Personal Julia Motta',
    // url: 'http://localhost:8080/personal-julia/slim/',
    // api: 'http://localhost:8080/personal-julia/slim/api/v1/',
}

export default env;
